import React from 'react';
export const AuthorInfo = () => {
  return <div className="flex items-center mb-6" data-id="element-189">
      <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="Sabrina Bauer" className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-190" />
      <div data-id="element-191">
        <h3 className="font-semibold text-gray-800" data-id="element-192">Sabrina Bauer</h3>
        <p className="text-gray-600 text-sm" data-id="element-193">
          Redakteurin Frauengesundheit Wissen
        </p>
      </div>
    </div>;
};